import axios from 'axios';
import { store } from '../store';
import { Actions } from '../store/actions';
import Util from './index';

/**
 * @type {Axios}
 * @type {AxiosInstance}
 */
const instance = axios.create({
	baseURL: process.env.REACT_APP_SERVER_URL,
	headers: {
		'Content-Type': 'application/json',
	},
	withCredentials: true,
	xsrfCookieName: 'XSRF-TOKEN', // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
	xsrfHeaderName: 'X-XSRF-TOKEN', // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
});

// Add a request interceptor
instance.interceptors.request.use(function (config) {
	const state = store.getState();
	if (state && state.session && state.session.loggedIn) {
		config.headers.Authorization = `Bearer ${state.session.token}`;
	}
	return config;
});

instance.handleResponse = (response) => response.data;
instance.handleResponseError = function (error) {
	if (Util.isStatus(error, 401)) {
		store.dispatch(Actions.logout());
		throw error;
	} else throw error;
};

export const http = instance;
